let resolver = null

export function requestUserConfirmation (description) {
  return new Promise((resolve) => {
    resolver = resolve
    window.dispatchEvent(new CustomEvent('agent-confirm-request', {
      detail: { description }
    }))
  })
}

export function resolveConfirmation (allowed) {
  if (resolver) {
    resolver(allowed)
    resolver = null
  }
}
